export default __webpack_public_path__ + "static/media/Mobile_Track.6722bedf.svg";